import { action, computed, observable, makeObservable } from "mobx";
import { ProcessoExterno } from "../modelo/ProcessoExterno";
import { ProcessoImportacao } from "../modelo/ProcessoImportacao";
import FiltroImportacaoStore from "./FiltroImportacaoStore";

class ImportacaoProcessosStore {
    iniciada = false;
    codImportacao = '';

    isCarregandoProcessos: boolean = false;
    carregamentoProcessosConcluido: boolean = false;
    processosQuePodemSerImportados: ProcessoExterno[] = [];
    idProcessoPainelExpandido: number;
    abaSelecionada: number = 0;
    abertoModalImportacao: boolean = false;
    servidorAtribuidoLote: string = '-1';
    controleGabAtribuidoLote: number = -1;

    processosImportados: ProcessoImportacao[] = [];
    processosNoEscaninho: ProcessoImportacao[] = [];
    totalDeProcessosParaImportar: number = 1;

    processosParaImportar: string[] = [];

    constructor() {
        makeObservable(this, {
            isCarregandoProcessos: observable,
            carregamentoProcessosConcluido: observable,
            processosQuePodemSerImportados: observable,
            idProcessoPainelExpandido: observable,
            abaSelecionada: observable,
            processosImportados: observable,
            processosNoEscaninho: observable,
            totalDeProcessosParaImportar: observable,
            processosParaImportar: observable,
            abertoModalImportacao: observable,
            servidorAtribuidoLote: observable,
            controleGabAtribuidoLote: observable,
            processosComErro: computed,
            processosComSucesso: computed,
            adicionarProcessoimportado: action,
            adicionarProcessosImportados: action,
            adicionarProcessoNoEscaninho: action,
            selectionarTudo: action,
            inicializar: action,
            totalDeProcessosImportados: computed,
            totalDeProcessosCarregadosNoEscaninho: computed,
            totalDeProcessosRetornadosComErro: computed,
            progressoImportacao: computed,
            progressoTotal: computed,
            processosQuePodemSerImportadosFiltrado: computed
        });
    }

    get processosComErro() {
        return this.processosImportados.filter(proc => proc.erro);
    }
    get processosComSucesso() {
        return this.processosImportados.filter(proc => !proc.erro);
    }

    adicionarProcessoimportado = (processo : ProcessoImportacao) => {
        const jaAdicionado = this.processosImportados.find(proc => proc.numero === processo.numero);
        if(!jaAdicionado){
            this.processosImportados.push(processo);
        }
    };

    adicionarProcessosImportados = (processos : ProcessoImportacao[]) => {
        const processoAAdicionar = processos.filter(processo => !this.processosImportados.find(proc => proc.numero === processo.numero));
        this.processosImportados = this.processosImportados.concat(processoAAdicionar);
    };

    adicionarProcessoNoEscaninho = (processo: ProcessoImportacao) => {
        const jaAdicionado = this.processosNoEscaninho.some(processoCarregado => processoCarregado.numero === processo.numero);
        if (!jaAdicionado) {
            this.processosNoEscaninho.push(processo);
        }
    };

    selectionarTudo = (selecionar: boolean) => {
        this.processosQuePodemSerImportadosFiltrado.forEach(processo => {
            processo.selecionar(selecionar);
        });
    };

    inicializar = () => {
        this.carregamentoProcessosConcluido = false;
        this.processosQuePodemSerImportados = [];
        this.idProcessoPainelExpandido = undefined;
        this.abaSelecionada = 0;
        this.processosImportados = [];
        this.processosNoEscaninho = [];
        this.totalDeProcessosParaImportar = 1;
    };

    get totalDeProcessosImportados(): number {
        return this.processosImportados.length;
    }

    get totalDeProcessosCarregadosNoEscaninho(): number {
        return this.processosNoEscaninho.length;
    }

    get totalDeProcessosRetornadosComErro(): number {
        return this.processosComErro.length;
    }

    get progressoImportacao() {
        return 100 * this.totalDeProcessosCarregadosNoEscaninho / this.totalDeProcessosParaImportar;
    }

    get progressoTotal() {
        const processosImportados = this.processosComErro.length + this.processosComSucesso.length;
        return 100 * processosImportados / this.totalDeProcessosParaImportar;
    }

    get processosQuePodemSerImportadosFiltrado(): ProcessoExterno[] {
        return FiltroImportacaoStore.aplicarFiltros(this.processosQuePodemSerImportados);
    }

    deveRenderizar(idProcesso: number) {
        if (
            this.idProcessoPainelExpandido === undefined ||
            idProcesso !== this.idProcessoPainelExpandido
        ) {
            return false;
        }
        return true;
    }
}

export default new ImportacaoProcessosStore();
